import { styled } from '@mui/material/styles'

const CardActions = styled('div')(({ theme }) => ({
  display: 'flex',
  backgroundColor: theme.palette.grey[500],
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '5px',
}))
export default CardActions
